import React, { useEffect, useState } from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48784999153883:1';
const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48784999678171:1';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 38
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (v: number) => v.toString().padStart(2, '0');
  return <section className="bg-brand-grayLight py-20 px-5 relative overflow-hidden" data-id="element-111">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-112">
        <h2 className="md:text-4xl font-black mb-12 text-center text-slate-900 text-[24px]" data-id="element-113">
          Podés seguir improvisando... o empezar a tener claridad desde hoy.
        </h2>

        <div className="text-center mb-12" data-id="element-114">
          <p className="text-sm text-slate-500 mb-6 font-bold uppercase tracking-widest" data-id="element-115">
            🚨 El precio de lanzamiento termina pronto:
          </p>
          <div className="flex items-end justify-center gap-3 mb-4" data-id="element-116">
            <div className="text-center" data-id="element-117">
              <span className="text-5xl md:text-6xl font-black text-slate-900" data-id="element-118">
                {fmt(timeLeft.hours)}
              </span>
              <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mt-2" data-id="element-119">
                HS
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-[#C8A96B] pb-3" data-id="element-120">
              :
            </span>
            <div className="text-center" data-id="element-121">
              <span className="text-5xl md:text-6xl font-black text-slate-900" data-id="element-122">
                {fmt(timeLeft.minutes)}
              </span>
              <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mt-2" data-id="element-123">
                MIN
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-[#C8A96B] pb-3" data-id="element-124">
              :
            </span>
            <div className="text-center" data-id="element-125">
              <span className="text-5xl md:text-6xl font-black text-slate-900" data-id="element-126">
                {fmt(timeLeft.seconds)}
              </span>
              <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mt-2" data-id="element-127">
                SEG
              </p>
            </div>
          </div>
          <p className="text-sm text-slate-500 font-bold" data-id="element-128">
            Después sube y esta oferta desaparece.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-129">
          <div className="bg-white border border-slate-100 rounded-2xl p-8 text-center flex flex-col transition-all hover:shadow-lg" data-id="element-130">
            <div className="text-4xl mb-4" data-id="element-131">📘</div>
            <h4 className="text-sm font-black text-slate-900 uppercase mb-2" data-id="element-132">
              MEGAPACK COLORIMETRÍA PRO™
            </h4>
            <p className="text-xs text-slate-500 mb-6 font-bold" data-id="element-133">
              6 Tomos + 6 Bonos
            </p>
            <div className="mt-auto" data-id="element-134">
              <div className="text-3xl font-black text-slate-900 mb-6" data-id="element-135">
                $19.990 ARS
              </div>
              <a href={checkoutBasico} className="block w-full border-2 border-slate-900 text-slate-900 font-black text-sm py-4 px-4 rounded-xl hover:bg-slate-50 transition-colors text-center no-underline" data-id="element-136">
                QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-white border-2 border-[#C8A96B] rounded-2xl p-8 text-center flex flex-col transition-all hover:shadow-xl hover:scale-[1.02] relative" data-id="element-137">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C8A96B] text-white text-[10px] font-black px-4 py-1 rounded-full uppercase tracking-widest" data-id="element-138">
              Recomendado
            </div>
            <div className="text-4xl mb-4" data-id="element-139">🏆</div>
            <h4 className="text-sm font-black text-slate-900 uppercase mb-2" data-id="element-140">
              MEGAPACK + SISTEMA ⭐
            </h4>
            <p className="text-xs text-slate-500 mb-6 font-bold" data-id="element-141">
              6 Tomos + 6 Bonos + Sistema + Kit
            </p>
            <div className="mt-auto" data-id="element-142">
              <div className="text-3xl font-black text-slate-900 mb-6" data-id="element-143">
                $27.990 ARS
              </div>
              <a href={checkoutCompleto} className="block w-full btn-premium font-black text-sm py-4 px-4 rounded-[20px] transition-all text-center no-underline" data-id="element-144">
                QUIERO TODO EL SISTEMA
              </a>
            </div>
          </div>
        </div>

        <div className="text-center space-y-4 mt-12" data-id="element-145">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-xs font-bold text-slate-400" data-id="element-146">
            <div className="flex items-center gap-2" data-id="element-147">
              <Lock size={16} className="text-brand-gold" data-id="element-148" />
              Pago 100% seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-149">
              <Zap size={16} className="text-brand-gold" data-id="element-150" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-151">
              <ShieldCheck size={16} className="text-brand-gold" data-id="element-152" />
              Garantía total
            </div>
          </div>
        </div>
      </div>
    </section>;
}